import {
    BookOpen, Target, Users, Scale, Shield, FileText, BarChart3, Zap,
    LayoutDashboard, Play, ClipboardCheck, Settings, History, SlidersHorizontal,
    CheckCircle2, AlertTriangle, XCircle, Activity
} from 'lucide-react';

export const CONSOLE_CATEGORIES = [
    { key: 'definition', label: '정의', icon: BookOpen },
    { key: 'applicability', label: '적용범위', icon: Target },
    { key: 'education', label: '교육', icon: Users },
    { key: 'penalty', label: '벌칙/처벌', icon: Scale },
    { key: 'risk_assessment', label: '위험성평가', icon: Shield },
    { key: 'procedure', label: '절차', icon: FileText },
    { key: 'numeric_standard', label: '수치기준', icon: BarChart3 },
    { key: 'duty', label: '사업주의무', icon: Zap },
    { key: 'rights', label: '근로자권리', icon: Users },
    { key: 'contracting', label: '도급/원청', icon: Settings },
];

export const CONSOLE_TABS = [
    { key: 'dashboard',   label: '현황',        path: '/ai/admin/console',             icon: LayoutDashboard },
    { key: 'standard_qa', label: '표준 Q&A',    path: '/ai/admin/console/standard-qa', icon: FileText,         stage: '1단계' },
    { key: 'evaluation',  label: 'AI 평가',     path: '/ai/admin/console/evaluation',  icon: Play,             stage: '2단계' },
    { key: 'review',      label: '결과 검토',   path: '/ai/admin/console/review',      icon: ClipboardCheck,   stage: '3단계' },
    { key: 'policy',      label: '규칙 관리',   path: '/ai/admin/console/policy',      icon: Settings,         stage: '4단계' },
    { key: 'history',     label: '처리 이력',   path: '/ai/admin/console/history',     icon: History },
    { key: 'settings',    label: '시스템 설정',  path: '/ai/admin/console/settings',   icon: SlidersHorizontal },
    { key: 'health',      label: '시스템 상태',  path: '/ai/admin/console/health',     icon: Activity },
];

export const CONSOLE_VERDICT_STYLE = {
    PASS: { bg: 'bg-emerald-100', text: 'text-emerald-700', icon: CheckCircle2 },
    WARN: { bg: 'bg-amber-100', text: 'text-amber-700', icon: AlertTriangle },
    FAIL: { bg: 'bg-red-100', text: 'text-red-700', icon: XCircle },
};

export const getVBg = (v) => CONSOLE_VERDICT_STYLE[v]?.bg ?? 'bg-gray-100';
export const getVText = (v) => CONSOLE_VERDICT_STYLE[v]?.text ?? 'text-gray-600';
export const getScoreColor = (s) => s >= 90 ? 'text-emerald-500' : s >= 70 ? 'text-amber-500' : 'text-red-500';
